import { PURGE } from 'redux-persist'
import remove from 'lodash.remove'
import {
  SET_SYNONYMOUS_TEXT,
  ADD_SYNONYMOUS_TEXT,
  REMOVE_SYNONYMOUS_TEXT,
  UPDATE_SYNONYMOUS_TEXT,
  // SHOW_SYNONYMOUS_TEXT,
  // LIST_SYNONYMOUS_TEXTS,
  SET_PARAPHRASE_TEXT,
  ADD_PARAPHRASE_TEXT,
  REMOVE_PARAPHRASE_TEXT,
  UPDATE_PARAPHRASE_TEXT,
  // SHOW_PARAPHRASE_TEXT,
  // LIST_PARAPHRASE_TEXTS,
  // ADD_SPINTAX_TEXT,
  // REMOVE_SPINTAX_TEXT,
  // UPDATE_SPINTAX_TEXT,
  // SHOW_SPINTAX_TEXT,
  // LIST_SPINTAX_TEXTS,
} from '../actions'

const INIT_STATE = {
  synonymous: [],
  paraphrase: [],
  summarize: [],
  spintax: []
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    // ACTION.TYPE DA FERRAMENTA SYNONYMOUS
    case SET_SYNONYMOUS_TEXT: {
      return { ...state, synonymous: action.payload }
    }
    case ADD_SYNONYMOUS_TEXT: {
      const { synonymous } = state
      synonymous.unshift(action.payload)
      return { ...state, synonymous }
    }
    case REMOVE_SYNONYMOUS_TEXT: {
      const textID = action.payload
      const { synonymous } = state
      remove(synonymous, text => text._id === textID)
      return { ...state, synonymous }
    }
    case UPDATE_SYNONYMOUS_TEXT: {
      const { textID, paragraphs } = action.payload
      const { synonymous } = state
      const synonymousText = synonymous.filter(text => text._id === textID)
      synonymousText.paragraphs = paragraphs
      return { ...state, synonymous, synonymousText }
    }
    // ACTION.TYPE DA FERRAMENTA PARAPHRASE
    case SET_PARAPHRASE_TEXT: {
      return { ...state, paraphrase: action.payload }
    }
    case ADD_PARAPHRASE_TEXT: {
      const { paraphrase } = state
      paraphrase.unshift(action.payload)
      return { ...state, paraphrase }
    }
    case REMOVE_PARAPHRASE_TEXT: {
      const textID = action.payload
      const { paraphrase } = state
      remove(paraphrase, text => text._id === textID)
      return { ...state, paraphrase }
    }
    case UPDATE_PARAPHRASE_TEXT: {
      const { textID, text } = action.payload
      const paraphrase = state.paraphrase.map((paraphrasedText) => {
        if (paraphrasedText._id === textID) paraphrasedText.newText = text
        return paraphrasedText
      })
      return { ...state, paraphrase }
    }
    case PURGE:
      return INIT_STATE
    default:
      return state
  }
}
